import { useState, useEffect, useCallback } from "react";
import api from "../../../../../../services/api";

// Estado e busca dos anexos de CIRCUITO (não de nó do diagrama, que continuam em
// diagramaEquipamentos/index.js — cada um já tinha seu próprio cache e ciclo de vida
// antes desta extração, então não foram unificados). Extraído de circuito/index.js
// (etapa 19, passo 2, do plano de melhorias).
//
// Escopo deliberadamente restrito ao estado + fetch + revogação de blob: a orquestração
// do save em si (o Promise.all que dispara delete/create de anexo de circuito E de nó
// juntos, com a classificação de falha/retry combinando os dois) PERMANECE em handleSave
// (circuito/index.js). Separar essa parte exigiria reestruturar a concorrência dos 4
// grupos de requisição (hoje um Promise.all só, cobrindo circuito+nó) e a contagem de
// falhas (hoje soma os 4 grupos numa mensagem só) — risco real de regressão numa lógica
// que já teve 3 bugs reais encontrados por revisão adversarial (etapa 6 do plano). Não
// vale o risco só para reduzir linhas.
export default function useCircuitoAnexosSave({ circuitoId }) {
  const [circuitoAnexos, setCircuitoAnexos] = useState([]);
  const [deletedAnexos, setDeletedAnexos] = useState([]);

  // Revoga blob URLs de anexos novos (preview local) antes de descartá-los do estado —
  // sem isso, cada save/reset vazava a memória do blob (nunca era revogado). useCallback
  // com deps vazias: identidade estável evita instabilidade em cascata em handleSave/handleReset
  const revokeNewFilesPreviews = useCallback((arquivos, manterSet = null) => {
    (arquivos || []).forEach((arquivo) => {
      if (arquivo?.isNew && arquivo?.preview && !manterSet?.has(arquivo)) {
        URL.revokeObjectURL(arquivo.preview);
      }
    });
  }, []);

  // useCallback: identidade estável entre renders (só muda com circuitoId), consumida por handleSave/handleReset
  const fetchAnexosCircuito = useCallback(async () => {
    if (!circuitoId) {
      setCircuitoAnexos((prev) => {
        revokeNewFilesPreviews(prev);
        return [];
      });
      return;
    }
    try {
      const response = await api.post("/anexos/findMany", {
        entityType: "Circuito",
        entityId: circuitoId,
      });
      setCircuitoAnexos((prev) => {
        revokeNewFilesPreviews(prev);
        return response?.data || [];
      });
    } catch (error) {
      console.error("Erro ao buscar anexos do circuito:", error);
    }
  }, [circuitoId, revokeNewFilesPreviews]);

  useEffect(() => {
    fetchAnexosCircuito();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [circuitoId]);

  return {
    circuitoAnexos,
    setCircuitoAnexos,
    deletedAnexos,
    setDeletedAnexos,
    revokeNewFilesPreviews,
    fetchAnexosCircuito,
  };
}
